const style = `
  <style>
    :host {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .link-to-regimen {
      font-size: 14px;
      font-weight: normal;
      color: #8F9494;
      margin: 10px 0;
    }

    h3 {
      text-transform: uppercase;
      font-size: 13px;
      font-weight: normal;
      color: #8F9494;
      margin: 10px 0;
    }

    h2 {
      font-family: GT-America-Standard-Bold, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 18px;
      display: block;
      font-weight: 400;
    }

    .customizations-container {
      border-top: 1px solid #D2EAE5;
      border-bottom: 1px solid #D2EAE5;
      padding-bottom: 10px;
    }

    .error-name-message {
      display: none;
      color: #CE5347;
      font-size: 14px;
      margin-top: 10px;
    }

    .error-name-message.show {
      display: block;
    }

    .input-name {
      border: 1px solid #C3C7C7;
      border-radius: 9px;
      padding: 10px;
      width: 30%;
      box-sizing: border-box;
    }

    .with-discount {
      color: grey;
      text-decoration: line-through;
    }

    .price-container {
      display: flex;
      gap: 10px;
    }

    .discount-badge {
      background-color: #8AE5D3;
      padding: 1px 10px;
      border-radius: 3px;
    }

    .checkbox-container {
      display: flex;
      gap: 5px;
      align-items: center;
    }

    input[type="checkbox"] {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      width: 16px;
      height: 16px;
      border: 1px solid #C3C7C7;
      background-color: transparent;
      display: inline-block;
      position: relative;
      cursor: pointer;
    }

    input[type="checkbox"]:checked {
      background-color: #3DC1A5;
    }

    input[type="checkbox"]:checked::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FFFFFF'%3E%3Cpath d='M20.285 6.293a1 1 0 011.414 1.414l-10 10a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 15.586l9.285-9.293z'/%3E%3C/svg%3E")
        no-repeat center;
      background-size: 12px;
    }

    .add-to-cart-text {
      text-transform: uppercase;
    }

    .quantity-wrapper {
      display: flex;
      gap: 15px;
    }

    @media (max-width: 900px) {
      h3 {
        font-size: 12px;
      }
    }

    @media (max-width: 768px) {
      .input-name {
        width: 76%;
      }
    }
  </style>
`;

export { style };
